/**
 * Pure HTML/CSS/JS Confetti Effect
 * Based on: https://dev.to/devlawrence/creating-a-confetti-effect-from-scratch-using-html-css-and-javascript-4poi
 */

interface ConfettiOptions {
  particleCount?: number;
  colors?: string[];
  origin?: { x: number; y: number };
}

export function createConfetti(options: ConfettiOptions = {}) {
  const {
    particleCount = 50,
    colors = ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8'],
    origin = { x: 0.5, y: 0.5 }
  } = options;

  // Create container for confetti
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.pointerEvents = 'none';
  container.style.zIndex = '9999';
  document.body.appendChild(container);

  // Calculate origin position in pixels
  const originX = window.innerWidth * origin.x;
  const originY = window.innerHeight * origin.y;

  // Create confetti particles
  for (let i = 0; i < particleCount; i++) {
    const confetti = document.createElement('div');
    const color = colors[Math.floor(Math.random() * colors.length)];

    // Random size between 5-15px
    const size = Math.random() * 10 + 5;

    // Random shape (square or circle)
    const isCircle = Math.random() > 0.5;

    confetti.style.position = 'absolute';
    confetti.style.width = `${size}px`;
    confetti.style.height = `${size}px`;
    confetti.style.backgroundColor = color;
    confetti.style.left = `${originX}px`;
    confetti.style.top = `${originY}px`;
    confetti.style.borderRadius = isCircle ? '50%' : '0';
    confetti.style.opacity = '1';

    // Random velocity and direction
    const velocityX = (Math.random() - 0.5) * 400; // -200 to 200
    const velocityY = Math.random() * -400 - 100; // -100 to -500 (upward)
    const rotation = Math.random() * 360;
    const rotationSpeed = (Math.random() - 0.5) * 10;

    container.appendChild(confetti);

    // Animate the confetti
    let posX = originX;
    let posY = originY;
    let velX = velocityX;
    let velY = velocityY;
    let rot = rotation;
    let opacity = 1;
    let time = 0;

    const animate = () => {
      time += 0.016; // Approximately 60fps

      // Apply gravity and velocity
      velY += 400 * 0.016; // Gravity
      posX += velX * 0.016;
      posY += velY * 0.016;
      rot += rotationSpeed;

      // Fade out near the end
      if (time > 2) {
        opacity -= 0.016 * 2;
      }

      // Update position
      confetti.style.left = `${posX}px`;
      confetti.style.top = `${posY}px`;
      confetti.style.transform = `rotate(${rot}deg)`;
      confetti.style.opacity = `${Math.max(0, opacity)}`;

      // Continue animation or clean up
      if (opacity > 0 && posY < window.innerHeight + 100) {
        requestAnimationFrame(animate);
      } else {
        confetti.remove();
      }
    };

    // Start animation with slight delay for each particle
    setTimeout(() => requestAnimationFrame(animate), i * 5);
  }

  // Clean up container after all animations are done
  setTimeout(() => {
    container.remove();
  }, 4000);
}

export function celebrateAchievement() {
  console.log('🎊 celebrateAchievement called!');

  // Create 3 bursts at random positions with delays
  const positions = [
    { x: Math.random() * 0.3 + 0.1, y: Math.random() * 0.4 + 0.3 }, // left
    { x: Math.random() * 0.3 + 0.35, y: Math.random() * 0.4 + 0.3 }, // center
    { x: Math.random() * 0.3 + 0.6, y: Math.random() * 0.4 + 0.3 }  // right
  ];

  positions.forEach((pos, index) => {
    setTimeout(() => {
      console.log(`✨ Confetti burst ${index + 1} at position:`, pos);
      createConfetti({
        particleCount: 30,
        colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8'],
        origin: pos
      });
    }, index * 1000);
  });
}
